import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useCallback } from "react";
import { Link, useParams, NavLink, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Collapse from "react-bootstrap/Collapse";
import Select from "react-select";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Formik } from "formik";
import * as yup from "yup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { AutoTabProvider } from "react-auto-tab";
import { ThailandAddressTypeahead, ThailandAddressValue } from "react-thailand-address-typeahead";
import DataTableLayout from "layouts/DatatableLayout";
import DownloadExcel from "utils/DownloadExcel";
import moment from "moment";
import { nanoid } from "nanoid";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { defaultOption } from "constants/ui/options";
import { getSupplierBranch, getSupplierFullName, getSupplierMainContactFullName, mapMstToOptions, getPrefixName } from "utils/HelperFunction";
import { groupQueryFilter } from "utils/HelperAdvancedFilter";
import { getFullUrlPath } from "utils/HandleFileFunction";
import { Visibility } from "@mui/icons-material";
import { Avatar, Stack } from "@mui/material";
import { getAllPartnerInfo } from "../../redux/handlers/partner/getAllPartnerInfo.handler";
import { partnerData } from "mocks/partnerData";
import DatatableLayoutPagination from "layouts/DatatableLayoutPagination";
import PartnerCreateModal from "./PartnerCreateModal";
export function ManagePartner() {
    var _useState = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 10,
        width: 560,
        height: 740,
        pin: false,
        mode: "normal",
        modalname: "partner-create"
    }), 2), createPartnerModal = _useState[0], setCreatePartnerModal = _useState[1];
    var openCreatePartner = function() {
        setCreatePartnerModal(function(previous) {
            return _object_spread_props(_object_spread({}, previous), {
                open: true,
                width: Math.min(560, window.innerWidth - 24),
                height: Math.min(740, window.innerHeight - 24),
                mode: "normal"
            });
        });
    };
    var handleCreatePartner = function() {
        var _ref = _async_to_generator(function(payload) {
            return _ts_generator(this, function(_state) {
                // API integration point: dispatch the create handler with payload here.
                // Do not persist or log registration credentials while the API is unavailable.
                if (!payload) throw new Error("Missing Partner data");
                return [
                    2,
                    {
                        message: "ตรวจสอบข้อมูลเรียบร้อยแล้ว ยังไม่ได้สร้าง Partner เนื่องจากยังไม่เชื่อมต่อ API"
                    }
                ];
            });
        });
        return function handleCreatePartner(payload) {
            return _ref.apply(this, arguments);
        };
    }();
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState1 = _sliced_to_array(useState([]), 2), tabledata = _useState1[0], setTabledata = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), excelData = _useState2[0], setExcelData = _useState2[1];
    var _useState3 = _sliced_to_array(useState(1), 2), tabMenuTb = _useState3[0], setTabMenuTb = _useState3[1];
    var _useState4 = _sliced_to_array(useState(0), 2), statusItem = _useState4[0], setStatusItem = _useState4[1];
    var _useState5 = _sliced_to_array(useState(""), 2), filterText = _useState5[0], setFilterText = _useState5[1];
    var _useState6 = _sliced_to_array(useState([]), 2), filteredItems = _useState6[0], setFilteredItems = _useState6[1];
    var _useState7 = _sliced_to_array(useState(1), 2), pageId = _useState7[0], setPageId = _useState7[1];
    var _useState8 = _sliced_to_array(useState(10), 2), pageSize = _useState8[0], setPageSize = _useState8[1];
    var _useState9 = _sliced_to_array(useState([]), 2), sortModel = _useState9[0], setSortModel = _useState9[1];
    var _useState10 = _sliced_to_array(useState(false), 2), loading = _useState10[0], setLoading = _useState10[1];
    var _useState11 = _sliced_to_array(useState(0), 2), totalPage = _useState11[0], setTotalPage = _useState11[1];
    var _useState12 = _sliced_to_array(useState(0), 2), totalAmount = _useState12[0], setTotalAmount = _useState12[1];
    var _useState13 = _sliced_to_array(useState(""), 2), typeId = _useState13[0], setTypeId = _useState13[1];
    var _useState14 = _sliced_to_array(useState(""), 2), sDate = _useState14[0], setSDate = _useState14[1];
    var _useState15 = _sliced_to_array(useState(""), 2), eDate = _useState15[0], setEDate = _useState15[1];
    var _useState16 = _sliced_to_array(useState(false), 2), searchLoad = _useState16[0], setSearchLoad = _useState16[1];
    var businesstype = [
        {
            value: "",
            label: "ทั้งหมด"
        },
        {
            value: 1,
            label: "บุคคลธรรมดา"
        },
        {
            value: 2,
            label: "นิติบุคคล"
        }
    ];
    var getAllPartnerInfoReducer = useAppSelector(function(state) {
        return state.getAllPartnerInfoReducer;
    });
    useEffect(function() {
        var data = _object_spread({
            pageId: pageId,
            pageSize: pageSize
        }, sDate && {
            sDate: moment(sDate).format("YYYY-MM-DD")
        }, eDate && {
            eDate: moment(eDate).format("YYYY-MM-DD")
        }, typeId && {
            type: typeId
        }, sortModel && {
            sortField: sortModel.sortField,
            sortValue: sortModel.sortValue
        }, filterText && {
            search: filterText
        }, statusItem > 0 && {
            status: statusItem
        });
        dispatch(getAllPartnerInfo(data, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, [
        pageId,
        pageSize,
        sortModel,
        typeId,
        sDate,
        eDate,
        filterText,
        statusItem
    ]);
    useEffect(function() {
        setIsLoading(getAllPartnerInfoReducer.isFetching);
        if (getAllPartnerInfoReducer.data && !getAllPartnerInfoReducer.isError) {
            var _getAllPartnerInfoReducer_data_data, _getAllPartnerInfoReducer_data, _getAllPartnerInfoReducer_data1;
            var pagination = (getAllPartnerInfoReducer === null || getAllPartnerInfoReducer === void 0 ? void 0 : (_getAllPartnerInfoReducer_data = getAllPartnerInfoReducer.data) === null || _getAllPartnerInfoReducer_data === void 0 ? void 0 : (_getAllPartnerInfoReducer_data_data = _getAllPartnerInfoReducer_data.data) === null || _getAllPartnerInfoReducer_data_data === void 0 ? void 0 : _getAllPartnerInfoReducer_data_data.pagination) || {};
            setTabledata(getAllPartnerInfoReducer === null || getAllPartnerInfoReducer === void 0 ? void 0 : (_getAllPartnerInfoReducer_data1 = getAllPartnerInfoReducer.data) === null || _getAllPartnerInfoReducer_data1 === void 0 ? void 0 : _getAllPartnerInfoReducer_data1.data);
            setTotalPage((pagination === null || pagination === void 0 ? void 0 : pagination.totalPage) || 0);
            setTotalAmount((pagination === null || pagination === void 0 ? void 0 : pagination.total) || 0);
        }
    }, [
        getAllPartnerInfoReducer
    ]);
    var columns = [
        {
            name: "รหัส Partner",
            selector: function(row) {
                return row.mb_mem_code;
            },
            width: "170px",
            center: "true",
            sortable: true,
            sortField: "mb_mem_code",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "/manage_partner/view/" + row.bus_business_id,
                        children: row.mb_mem_code && row.mb_mem_code != "" && row.mb_mem_code != null ? row.mb_mem_code : "ไม่มีรหัส"
                    })
                });
            }
        },
        {
            name: "รหัส VENDOR",
            selector: function(row) {
                return row.bus_business_vendorcode;
            },
            sortable: true,
            sortField: "bus_business_vendorcode",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "/manage_partner/view/" + row.bus_business_id,
                        children: row.bus_business_vendorcode && row.bus_business_vendorcode != null && row.bus_business_vendorcode != "" ? row.bus_business_vendorcode : "-"
                    })
                });
            },
            width: "170px",
            center: "true"
        },
        {
            name: "วันที่ขออนุมัติ",
            selector: function(row) {
                return row.bus_business_credate && row.bus_business_credate != null && row.bus_business_credate != "" ? moment(row.bus_business_credate).format("DD/MM/YYYY") : "-";
            },
            center: "true",
            sortable: true,
            width: "180px",
            sortField: "bus_business_credate"
        },
        {
            name: "ชื่อธุรกิจ",
            selector: function(row) {
                return row.bus_business_name;
            },
            width: "300px",
            sortable: true,
            sortField: "bus_business_name",
            cell: function(row, index, column, id) {
                return row.bus_business_businesstype == 2 ? /*#__PURE__*/ _jsx(_Fragment, {
                    children: row.bus_business_name && row.bus_business_name != "" && row.bus_business_name != null ? row.bus_business_comprefixname + row.bus_business_name + row.bus_business_suffixname : "-"
                }) : row.bus_business_businesstype == 1 ? /*#__PURE__*/ _jsx(_Fragment, {
                    children: row.bus_business_fname && row.bus_business_fname != "" && row.bus_business_fname != null ? getPrefixName(row.bus_business_prefixid) + row.bus_business_fname + " " + row.bus_business_lname : "-"
                }) : /*#__PURE__*/ _jsx(_Fragment, {
                    children: "-"
                });
            }
        },
        {
            name: "เลขผู้เสียภาษี",
            selector: function(row) {
                return row.bus_business_taxid && row.bus_business_taxid != null && row.bus_business_taxid != "" ? row.bus_business_taxid : "-";
            },
            center: "true",
            width: "200px",
            sortable: true,
            sortField: "bus_business_taxid"
        },
        {
            name: "ประเภท",
            selector: function(row) {
                return row.bus_business_businesstype;
            },
            width: "180px",
            sortable: true,
            sortField: "bus_business_businesstype",
            center: "true",
            cell: function(row, index, column, id) {
                return row.bus_business_businesstype == 1 && /*#__PURE__*/ _jsx(_Fragment, {
                    children: "บุคคลธรรมดา"
                }) || row.bus_business_businesstype == 2 && /*#__PURE__*/ _jsx(_Fragment, {
                    children: "นิติบุคคล"
                }) || "-";
            }
        },
        {
            name: "จำนวนสินค้าที่นำเสนอ",
            width: "200px",
            selector: function(row) {
                return row.pd_product_count || 0;
            },
            center: "true",
            sortable: true,
            sortField: "pd_product_count"
        },
        {
            name: "บัญชีธนาคาร",
            selector: function(row) {
                return row.bus_business_bankstatus;
            },
            center: "true",
            width: "180px",
            sortable: true,
            sortField: "bus_business_bankstatus",
            cell: function(row, index, column, id) {
                return row.bus_business_bankstatus == 3 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(114, 225, 40, 0.87)",
                        backgroundColor: "rgba(238, 251, 229, 1)",
                        borderRadius: "20px",
                        width: "130px"
                    },
                    children: "ตรวจสอบแล้ว"
                }) : row.bus_business_bankstatus == 2 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(253, 180, 40, 1)",
                        backgroundColor: "rgba(255, 246, 229, 1)",
                        borderRadius: "20px",
                        width: "130px"
                    },
                    children: "รอตรวจสอบ"
                }) : /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(116, 116, 116, 1)",
                        backgroundColor: "rgba(244, 244, 244, 1)",
                        borderRadius: "20px",
                        width: "130px"
                    },
                    children: "แบบร่าง"
                });
            }
        },
        {
            name: "เอกสาร",
            selector: function(row) {
                return row.bus_business_docstatus;
            },
            sortable: true,
            sortField: "bus_business_docstatus",
            center: "true",
            width: "180px",
            cell: function(row, index, column, id) {
                return row.bus_business_docstatus == 3 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(114, 225, 40, 0.87)",
                        backgroundColor: "rgba(238, 251, 229, 1)",
                        borderRadius: "20px",
                        width: "130px"
                    },
                    children: "ตรวจสอบแล้ว"
                }) : row.bus_business_docstatus == 2 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(253, 180, 40, 1)",
                        backgroundColor: "rgba(255, 246, 229, 1)",
                        borderRadius: "20px",
                        width: "130px"
                    },
                    children: "รอตรวจสอบ"
                }) : /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(116, 116, 116, 1)",
                        backgroundColor: "rgba(244, 244, 244, 1)",
                        borderRadius: "20px",
                        width: "130px"
                    },
                    children: "แบบร่าง"
                });
            }
        },
        {
            name: "สถานะ",
            selector: function(row) {
                return row.bus_business_status;
            },
            center: "true",
            width: "180px",
            sortable: true,
            sortField: "bus_business_status",
            cell: function(row, index, column, id) {
                return row.bus_business_status == 5 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(211, 47, 47, 1)",
                        backgroundColor: "rgba(253, 237, 237, 1)",
                        borderRadius: "20px",
                        width: "130px"
                    },
                    children: "ไม่อนุมัติ"
                }) : row.bus_business_status == 4 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#6f42c1",
                        backgroundColor: "#e2d9f3",
                        borderRadius: "20px",
                        width: "130px"
                    },
                    children: "รอแก้ไข"
                }) : row.bus_business_status == 3 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(114, 225, 40, 0.87)",
                        backgroundColor: "rgba(238, 251, 229, 1)",
                        borderRadius: "20px",
                        width: "130px"
                    },
                    children: "อนุมัติ"
                }) : row.bus_business_status == 2 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(253, 180, 40, 1)",
                        backgroundColor: "rgba(255, 246, 229, 1)",
                        borderRadius: "20px",
                        width: "130px"
                    },
                    children: "รออนุมัติ"
                }) : /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(116, 116, 116, 1)",
                        backgroundColor: "rgba(244, 244, 244, 1)",
                        borderRadius: "20px",
                        width: "130px"
                    },
                    children: "แบบร่าง"
                });
            }
        },
        {
            name: "จัดการ",
            selector: function(row) {
                return row.bus_business_id;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx(Stack, {
                    direction: "row",
                    spacing: 1,
                    sx: {
                        justifyContent: "center",
                        alignItems: "center"
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "/manage_partner/view/" + row.bus_business_id,
                        children: row.bus_business_id ? /*#__PURE__*/ _jsx(Avatar, {
                            sx: {
                                color: "rgba(253, 180, 40, 1)",
                                bgcolor: "rgba(255, 246, 229, 1)"
                            },
                            children: /*#__PURE__*/ _jsx(Visibility, {
                                sx: {
                                    fontSize: 30
                                }
                            })
                        }) : "-"
                    })
                });
            },
            width: "120px",
            center: "true"
        }
    ];
    useEffect(function() {
        var tableDataNew = [];
        if ((tabledata === null || tabledata === void 0 ? void 0 : tabledata.data) && (tabledata === null || tabledata === void 0 ? void 0 : tabledata.data.length) > 0) {
            tableDataNew = (tabledata === null || tabledata === void 0 ? void 0 : tabledata.data) || [];
            setFilteredItems(tableDataNew);
        } else {
            setFilteredItems([]);
        }
    }, [
        tabledata
    ]);
    useEffect(function() {
        if (filteredItems && filteredItems.length > 0) {
            filteredItems.map(function(item, index) {
                if (item.bus_business_id && item.bus_business_id != "" && item.bus_business_id > 0) {
                    setExcelData(function(excelData) {
                        return _to_consumable_array(excelData).concat([
                            {
                                partner_no: index + 1,
                                partner_code: item.mb_mem_code,
                                vendor_code: item.bus_business_vendorcode,
                                approval_date: item.bus_business_credate && item.bus_business_credate != null && item.bus_business_credate != "" ? moment(item.bus_business_credate).format("DD/MM/YYYY") : "-",
                                name_company: item.bus_business_name && item.bus_business_name != null && item.bus_business_name != "" ? item.bus_business_name : "-",
                                tax_numer: item.bus_business_taxid && item.bus_business_taxid != null && item.bus_business_taxid != "" ? item.bus_business_taxid : "-",
                                type_company: item.bus_business_businesstype && item.bus_business_businesstype == 2 ? "นิติบุคคล" : item.bus_business_businesstype && item.bus_business_businesstype == 1 ? "บุคคลธรรมดา" : "-",
                                product_amount: 0,
                                status_bank: item.bus_business_bankstatus && item.bus_business_bankstatus == 3 ? "ตรวจสอบแล้ว" : item.bus_business_bankstatus && item.bus_business_bankstatus == 2 ? "รอตรวจสอบ" : "แบบร่าง",
                                status_document: item.bus_business_docstatus && item.bus_business_docstatus == 3 ? "ตรวจสอบแล้ว" : item.bus_business_docstatus && item.bus_business_docstatus == 2 ? "รอตรวจสอบ" : "แบบร่าง",
                                status: item.bus_business_status && item.bus_business_status == 5 ? "ไม่อนุมัติ" : item.bus_business_status && item.bus_business_status == 4 ? "รอแก้ไข" : item.bus_business_status && item.bus_business_status == 3 ? "อนุมัติ" : item.bus_business_status && item.bus_business_status == 2 ? "รออนุมัติ" : "แบบร่าง"
                            }
                        ]);
                    });
                }
            });
        }
    }, [
        filteredItems
    ]);
    var handleChangePage = function(newPage) {
        setPageId(newPage);
    };
    var handleChangeRowsPerPage = function(newPageSize) {
        setPageSize(newPageSize);
    };
    var handleSort = function(column, sortDirection) {
        var field = column === null || column === void 0 ? void 0 : column.sortField;
        var value = sortDirection; // 'asc' หรือ 'desc'
        console.log("Sort:", {
            sortField: field,
            sortValue: value
        });
        setSortModel({
            sortField: field,
            sortValue: value
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item ",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการ Partner"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("li", {
                                    className: "breadcrumb-item active tc-1 ",
                                    "aria-current": "page",
                                    children: [
                                        " ",
                                        "รายละเอียด",
                                        " "
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "mb-2",
                        children: /*#__PURE__*/ _jsx("h3", {
                            className: "h3",
                            children: "จัดการ Partner"
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Row, {
                        className: "mb-2",
                        children: [
                            /*#__PURE__*/ _jsx(Col, {
                                xs: 4,
                                sm: "auto",
                                className: "d-grid",
                                children: /*#__PURE__*/ _jsx(Button, {
                                    className: "btn-category px-2 text-decoration-none",
                                    onClick: function() {
                                        setTabMenuTb(1);
                                        setStatusItem(0);
                                        setPageId(1);
                                    },
                                    active: tabMenuTb == 1 ? true : false,
                                    children: "ทั้งหมด"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Col, {
                                xs: 4,
                                sm: "auto",
                                className: "d-grid",
                                children: /*#__PURE__*/ _jsx(Button, {
                                    className: "btn-category px-2 text-decoration-none",
                                    onClick: function() {
                                        setTabMenuTb(2);
                                        setStatusItem(2);
                                        setPageId(1);
                                    },
                                    active: tabMenuTb == 2 ? true : false,
                                    children: "รออนุมัติ"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Col, {
                                xs: 4,
                                sm: "auto",
                                className: "d-grid",
                                children: /*#__PURE__*/ _jsx(Button, {
                                    className: "btn-category px-2 text-decoration-none",
                                    onClick: function() {
                                        setTabMenuTb(3);
                                        setStatusItem(3);
                                        setPageId(1);
                                    },
                                    active: tabMenuTb == 3 ? true : false,
                                    children: "อนุมัติ"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Col, {
                                xs: 4,
                                sm: "auto",
                                className: "d-grid",
                                children: /*#__PURE__*/ _jsx(Button, {
                                    className: "btn-category px-2 text-decoration-none",
                                    onClick: function() {
                                        setTabMenuTb(4);
                                        setStatusItem(4);
                                        setPageId(1);
                                    },
                                    active: tabMenuTb == 4 ? true : false,
                                    children: "รอแก้ไข"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Col, {
                                xs: 4,
                                sm: "auto",
                                className: "d-grid",
                                children: /*#__PURE__*/ _jsx(Button, {
                                    className: "btn-category px-2 text-decoration-none",
                                    onClick: function() {
                                        setTabMenuTb(5);
                                        setStatusItem(5);
                                        setPageId(1);
                                    },
                                    active: tabMenuTb == 5 ? true : false,
                                    children: "ไม่อนุมัติ"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "card card-st-2",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "card-body pt-4 pb-0",
                        children: /*#__PURE__*/ _jsxs(Row, {
                            className: "mx-0",
                            children: [
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: 12,
                                    md: 2,
                                    xl: 1,
                                    className: "mb-3 mt-[10px]",
                                    children: /*#__PURE__*/ _jsx(DownloadExcel, {
                                        data: excelData,
                                        filename: "manage_partner"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: 12,
                                    md: 10,
                                    xl: 4,
                                    children: /*#__PURE__*/ _jsxs(Stack, {
                                        direction: "row",
                                        justifyContent: "flex-start",
                                        sx: {
                                            mt: "10px"
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "mb-2 px-2 w-[280px] ml-8",
                                                children: "ค้นหาวันที่"
                                            }),
                                            /*#__PURE__*/ _jsx(DatePicker, {
                                                selected: sDate,
                                                onChange: function(date) {
                                                    return setSDate(date);
                                                },
                                                dateFormat: "dd-MM-yyyy",
                                                className: "form-control px-2 mb-2 w-100",
                                                isClearable: true
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "mb-2 px-2",
                                                children: "ถึง"
                                            }),
                                            /*#__PURE__*/ _jsx(DatePicker, {
                                                selected: eDate,
                                                onChange: function(date) {
                                                    return setEDate(date);
                                                },
                                                dateFormat: "dd-MM-yyyy",
                                                className: "form-control px-2 mb-2 w-100",
                                                isClearable: true
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: 12,
                                    md: 4,
                                    xl: 2,
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "form-st-3 p-0",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1 z-3",
                                                children: "ประเภทธุรกิจ"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                className: "w-100 select-st-3 z-2",
                                                placeholder: "ค้นหาประเภทธุรกิจ",
                                                options: businesstype,
                                                value: businesstype.find(function(opt) {
                                                    return opt.value === typeId;
                                                }) || "",
                                                onChange: function(e) {
                                                    return setTypeId(e ? e.value : "");
                                                },
                                                isClearable: true
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: 12,
                                    md: 8,
                                    xl: 5,
                                    className: "mb-3",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "d-flex flex-wrap flex-sm-nowrap align-items-center gap-2 mt-[10px]",
                                        children: [
                                            /*#__PURE__*/ _jsx("input", {
                                                type: "text",
                                                className: "form-control form-st-4 w-100",
                                                style: {
                                                    minWidth: 0
                                                },
                                                placeholder: "ค้นหารหัส Partner,รหัส VENDOR, ชื่อธุรกิจ, เลขผู้เสียภาษี",
                                                onKeyUp: function(e) {
                                                    setFilterText(e.target.value);
                                                    setPageId(1);
                                                }
                                            }),
                                            /*#__PURE__*/ _jsx(Button, {
                                                type: "button",
                                                className: "btn btn-dg flex-shrink-0 text-nowrap",
                                                onClick: openCreatePartner,
                                                children: "สร้าง Partner"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "card-body px-0 pt-4 pb-0",
                        children: /*#__PURE__*/ _jsx(DatatableLayoutPagination, {
                            item: filteredItems,
                            columns: columns,
                            isSelectRows: false,
                            currentPage: pageId,
                            currentPageSize: pageSize,
                            onChangePage: handleChangePage,
                            onChangePageSize: handleChangeRowsPerPage,
                            totalPage: totalPage,
                            totalAmount: totalAmount,
                            sortModel: sortModel,
                            onChangeSort: setSortModel,
                            handleSort: handleSort,
                            loading: loading
                        })
                    })
                ]
            }),
            createPartnerModal.open && /*#__PURE__*/ _jsx(PartnerCreateModal, {
                modal: createPartnerModal,
                setModal: setCreatePartnerModal,
                onSave: handleCreatePartner
            })
        ]
    });
}
